import { testimonials } from '../../../mocks/courses';

export default function Testimonials() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-teal-600 text-sm font-semibold uppercase tracking-widest mb-2">Student Reviews</p>
          <h2 className="text-4xl font-bold text-slate-900">What Our Students Say</h2>
          <p className="text-slate-500 mt-2">Real feedback from real learners who transformed their careers</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map(t => (
            <div key={t.id} className="bg-slate-50 rounded-2xl p-6 border border-slate-100">
              <div className="flex items-center gap-1 mb-4">
                {[1,2,3,4,5].map(i => (
                  <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm" />
                  </div>
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed mb-5">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-200">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <p className="text-sm font-semibold text-slate-800">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.role} · {t.course}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
